<template>
  <div class="content">
    <div class="main">
      <PeriodicExamineModal ref="PeriodicExamineModal" v-on:callbackSuccess="getData"></PeriodicExamineModal>
      <ConfigShow ref="ConfigShow"></ConfigShow>
      <startExamine ref="startExamine" v-on:execComplete="getExamineHistory()"></startExamine>
      <Modal width="1000" v-model="examineHistoryDetailModal" footer-hide>
        <div style="padding-right: 10px" v-if="examineHistoryDetail.content">
          <div class="exec-logs-detail-c">
            <Row v-if="examineHistoryDetail.started_format" class="exec-logs-detail-c-row">
              <span class="span-dt">开始时间: </span><span>{{ examineHistoryDetail.started_format }}</span>
            </Row>
            <Row v-if="examineHistoryDetail.ended_format" class="exec-logs-detail-c-row">
              <span class="span-dt">结束时间: </span><span>{{ examineHistoryDetail.ended_format }}</span>
            </Row>
            <Row v-if="examineHistoryDetail.use_time" class="exec-logs-detail-c-row">
              <span class="span-dt">耗时: </span><span>{{ examineHistoryDetail.use_time }}(秒)</span>
            </Row>
            <Row v-if="examineHistoryDetail.execute_user_full_name" class="exec-logs-detail-c-row">
              <span class="span-dt">执行用户: </span><span>{{ examineHistoryDetail.execute_user_full_name }}</span>
            </Row>
            <Row class="exec-logs-detail-c-row">
              <span class="span-dt">校验类型: </span>
              <span v-if="examineHistoryDetail.style === 'config'">检测常规配置</span>
              <span v-else-if="examineHistoryDetail.style === 'order'">检测命令输出</span>
            </Row>
            <Row v-if="examineHistoryDetail.status" class="exec-logs-detail-c-row">
              <span class="span-dt">状态: </span>
                <span v-if="examineHistoryDetail.status === '队列中'">
                <Icon type="md-clock" size="18" style="color: #2d8cf0" /><span style="color: #2d8cf0"> 队列中</span>
              </span>
                <span v-if="examineHistoryDetail.status === '完成'">
                <Icon type="md-checkmark" size="18" style="color: #19be6b" /><span style="color: #19be6b"> 完成</span>
              </span>
                <span v-if="examineHistoryDetail.status === '校验中'">
                <Icon type="ios-loading" size="18" style="color: #ff9900; animation: ani-demo-spin 1s linear infinite" />
                <span style="color: #ff9900"> 校验中</span>
              </span>
            </Row>
            <Row></Row>
            <Row v-if="examineHistoryDetail.style === 'config'" class="exec-logs-detail-c-row">
              <span class="span-dt">校验配置项: </span><span>{{ examineHistoryDetail.option }}</span>
            </Row>
            <Row v-if="examineHistoryDetail.style === 'config'" style="padding-left: 10px;">
              <span class="span-dt">校验实时配置: </span>
              <span v-if="examineHistoryDetail.is_real_time">是</span>
              <span v-else>否</span>
            </Row>
            <Row v-if="examineHistoryDetail.style === 'order'" style="padding-left: 10px;">
              <span class="span-dt">命令: </span><span>{{ examineHistoryDetail.cmd }}</span>
            </Row>
          </div>
          <Tabs :value="tab_value">
            <TabPane :label="no_global_valid_label" name="no_global_valid" style="min-height: 500px">
              <a :href="'#no_global_valid_' + index" v-for="(item, index) in examineHistoryDetail.no_global_valid"
                 :key="'no_global_valid_tag_' + index">
                <Tag color="error">{{ item.asset }}</Tag>
              </a>
              <div v-if="examineHistoryDetail.no_global_valid.length">
                <Divider orientation="left">详细列表</Divider>
                <div class="detail-list-logs-scroll-bar">
                  <div v-for="(c, index) in examineHistoryDetail.no_global_valid" :key="'no_global_valid_' + index">
                    <Row class="detail-log-list">
                      <a class="span-dt" style="padding-left: 10px" :name="'no_global_valid_' + index">设备名: </a>
                      <span>
                        {{ c.asset }}
                        <Badge :count="c.result.length" type="info"></Badge>
                      </span>
                      <a class="span-dt" style="padding-left: 20px" v-if="c.version">校验版本: </a>
                      <span v-if="c.version">{{ c.version }}</span>
                      <a style="padding-left: 10px" v-if="c.version_id" v-on:click="getConfigVersionHistoryDetail(c.version_id)">点击查看</a>
                      <div v-for="(row, result_index) in c.result" style="padding: 0 10px 0 5px; margin-bottom: 5px" :key="'no_global_valid_result_' + result_index">
                        <Card :bordered="false">
                          <span class="span-dt">值: </span>
                          <Tooltip placement="right" transfer :max-width="700">
                            <span>{{ row.value.substring(0, 100) }} <span v-if="row.value.length > 100"> ...</span></span>
                            <div slot="content">
                              <a v-on:click="dataCopy(row.value)">拷贝到剪贴板</a>
                              <pre style="white-space: pre-wrap; word-wrap: break-word;">{{ row.value }}</pre>
                            </div>
                          </Tooltip>
                          <div v-for="(valid_r, valid_r_index) in row.valid_result" :key="'no_global_valid_result_valid_r' + valid_r_index">
                            <span style="color: #19be6b" v-if="valid_r.valid">{{ valid_r.comment }} <Icon type="md-checkmark" /></span>
                            <span style="color: #ed4014" v-else>{{ valid_r.comment }} <Icon type="md-close" /></span>
                          </div>
                        </Card>
                      </div>
                    </Row>
                    <Divider></Divider>
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane :label="global_valid_label" name="global_valid">
              <a :href="'#global_valid_' + index" v-for="(item, index) in examineHistoryDetail.global_valid"
                 :key="'global_valid_tag_' + index">
                <Tag color="success">{{ item.asset }}</Tag>
              </a>
              <div v-if="examineHistoryDetail.global_valid.length">
                <Divider orientation="left">详细列表</Divider>
                <div class="detail-list-logs-scroll-bar">
                  <div v-for="(c, index) in examineHistoryDetail.global_valid" :key="'global_valid_' + index">
                    <Row class="detail-log-list">
                      <a class="span-dt" style="padding-left: 10px" :name="'global_valid_' + index">设备名: </a>
                      <span>
                        {{ c.asset }}
                        <Badge :count="c.result.length" type="info"></Badge>
                      </span>
                      <a class="span-dt" style="padding-left: 20px" v-if="c.version" >校验版本: </a>
                      <a style="padding-left: 10px" v-if="c.version_id" v-on:click="getConfigVersionHistoryDetail(c.version_id)">点击查看</a>
                      <span v-if="c.version">{{ c.version }}</span>
                      <div v-for="(row, result_index) in c.result" style="padding: 0 10px 0 5px; margin-bottom: 5px" :key="'global_valid_result_' + result_index">
                        <Card :bordered="false">
                          <span class="span-dt">值: </span>
                          <Tooltip placement="right" transfer :max-width="700">
                            <span>{{ row.value.substring(0, 100) }} <span v-if="row.value.length > 100"> ...</span></span>
                            <div slot="content">
                              <a v-on:click="dataCopy(row.value)">拷贝到剪贴板</a>
                              <pre style="white-space: pre-wrap; word-wrap: break-word;">{{ row.value }}</pre>
                            </div>
                          </Tooltip>
                          <div v-for="(valid_r, valid_r_index) in row.valid_result" :key="'global_valid_result_valid_r' + valid_r_index">
                            <span style="color: #19be6b" v-if="valid_r.valid">{{ valid_r.comment }} <Icon type="md-checkmark" /></span>
                            <span style="color: #ed4014" v-else>{{ valid_r.comment }} <Icon type="md-close" /></span>
                          </div>
                        </Card>
                      </div>
                    </Row>
                    <Divider></Divider>
                  </div>
                </div>
              </div>
            </TabPane>
            <TabPane :label="not_fount_label" name="not_fount">
              <Tag color="warning" v-for="(item, index) in examineHistoryDetail.not_fount" :key="'not_fount_tag_' + index">{{ item.asset }}</Tag>
            </TabPane>
            <TabPane :label="not_backup_label" name="not_backup">
              <Tag color="warning" v-for="(item, index) in examineHistoryDetail.not_backup" :key="'not_backup_tag_' + index">{{ item.asset }}</Tag>
            </TabPane>
            <TabPane :label="unreachable_label" name="nreachable">
              <Tag color="warning" v-for="(item, index) in examineHistoryDetail.unreachable" :key="'unreachable_tag_' + index">{{ item.asset }}</Tag>
            </TabPane>
          </Tabs>
        </div>
      </Modal>
      <div>
        <Row>
          <Col :xs="24" :sm="24" :md="24" :lg="24">
            <div>
              <Row class="title">
                <h4 :style="{float: 'left'}">策略详情</h4>
                <div :style="{float: 'right'}">
                  <Button type="success" @click="execModalOpen" style="margin-right: 10px">开始校验</Button>
                  <Button type="warning" @click="edit" style="margin-right: 10px">编辑</Button>
                  <Button @click="$router.push({ name: 'network_config_verify' })">返回</Button>
                </div>
              </Row>
              <Alert v-if="infoError" type="warning" show-icon>获取策略数据失败</Alert>
              <div class="info-property" v-else>
                <dl>
                  <dt>ID</dt><dd>{{ info.id }}</dd>
                </dl>
                <dl>
                  <dt>策略名称</dt><dd>{{ info.name }}</dd>
                </dl>
                <dl>
                  <dt>策略描述</dt><dd>{{ info.desc }}</dd>
                </dl>
                <dl>
                  <dt>定时校验</dt>
                  <dd v-if="info.periodic_task">
                    <Button :type="info.periodic_task.enabled ? 'success' : 'default'"
                            :icon="info.periodic_task.enabled ? 'md-checkmark' : 'md-close'"
                            @click="$refs.PeriodicExamineModal.openModal(info.id)"
                            style="margin-right: 10px"
                            size="small">定时校验</Button>
                  </dd>
                  <dd v-else>
                    <Button type="default"
                            icon="md-close"
                            @click="$refs.PeriodicExamineModal.openModal(info.id)"
                            style="margin-right: 10px"
                            size="small">定时校验</Button>
                  </dd>
                </dl>
                <dl>
                  <dt>校验类型</dt>
                  <dd v-if="info.style === 'config'">检测常规配置</dd>
                  <dd v-else-if="info.style === 'order'">检测命令输出</dd>
                </dl>
                <dl v-if="info.style === 'order'">
                  <dt>命令</dt>
                  <dd>{{ info.cmd }}</dd>
                </dl>
                <dl v-if="info.style === 'config'">
                  <dt>校验实时配置</dt>
                  <dd v-if="info.is_real_time">
                    <span>是</span>
                    <Alert show-icon>将校验设备实时配置！</Alert>
                  </dd>
                  <dd v-else>
                    <span>否</span>
                    <Alert show-icon>将校验设备最后一次备份的配置版本，若设备无备份，将校验失败！</Alert>
                  </dd>
                </dl>
                <dl v-if="info.style === 'config'">
                  <dt>校验配置项</dt><dd>{{ info.option }}</dd>
                </dl>
                <dl>
                  <dt>规则</dt>
                  <dd id="detail-rule">
                    <div v-for="(item, itemIndex) in info.rule" :key="itemIndex" style="padding-top: 5px; color: #fff;">
                      <Row>
                        <Tag style="float: left; margin-right: 5px;" color="success">规则 {{ itemIndex + 1 }}</Tag>
                        <Select style="width: 178px; float: left; margin-right: 5px;" placeholder="选择行" v-model="item.line_type" size="small" class="mob-f-unset"
                                v-if="info.style === 'order'" :disabled="true">
                          <Option value="every" key="every">任意行</Option>
                          <Option value="specify" key="specify">指定行</Option>
                        </Select>
                        <Select style="width: 178px; float: left; margin-right: 5px;" placeholder="选择满足行数" v-model="item.match_line" size="small" class="mob-f-unset"
                                v-if="info.style === 'order' && item.line_type === 'every'" :disabled="true">
                          <Option value="one" key="one">满足一行即可</Option>
                          <Option value="all" key="all">所有行都必须满足</Option>
                        </Select>
                        <Input v-model="item.line_number" size="small" style="width: 178px; float: left; margin-right: 5px; background: #fff;" placeholder="指定行号"
                               v-if="info.style === 'order' && item.line_type === 'specify'" class="mob-f-unset" :disabled="true"/>

                        <Select style="width: 178px; float: left; margin-right: 5px;color: #fff;" :disabled="true" placeholder="字符类型" v-model="item.type" size="small" class="mob-f-unset">
                          <Option v-for="typeItem in typeList" :value="typeItem.value" :key="typeItem.value">{{ typeItem.label }}</Option>
                        </Select>
                        <Select style="width: 178px; float: left; margin-right: 5px;" placeholder="匹配方式" v-model="item.style" :disabled="true" size="small" class="mob-f-unset">
                          <Option v-for="styleItem in styleList" :value="styleItem.value" :key="styleItem.value" v-if="styleItem.allowType.indexOf(item.type) > -1">{{ styleItem.label }}</Option>
                        </Select>
                        <Input v-model="item.keyword" size="small" style="width: 178px; float: left; background: #fff;" :disabled="true" placeholder="关键字 / 字符长度" v-if="item.style !== 'exist' && item.style !== 'nexist'" class="mob-f-unset"/>
                      </Row>
                    </div>
                  </dd>
                </dl>
                <dl>
                  <dt>创建用户</dt><dd>{{ info.create_user_full_name }}</dd>
                </dl>
                <dl>
                  <dt>创建时间</dt><dd>{{ info.created_format }}</dd>
                </dl>
                <dl>
                  <dt>最后修改用户</dt><dd>{{ info.change_user_full_name }}</dd>
                </dl>
                <dl>
                  <dt>最后修改时间</dt><dd>{{ info.changed_format }}</dd>
                </dl>
              </div>
            </div>
            <div>
              <Row class="title" :style="{marginTop: '15px'}">
                <h4 :style="{float: 'left'}">校验历史</h4>
                <a v-on:click="getExamineHistory()" style="line-height: 32px; padding-left: 10px"><Icon type="md-refresh" size="18"/></a>
              </Row>
              <Row>
                <Alert v-if="examineHistory.error" type="warning" show-icon>获取校验数据失败</Alert>
                <Table
                  v-else
                  border
                  size="small"
                  :loading="examineHistoryLoading"
                  ref="table"
                  :data="examineHistory.data"
                  :columns="examineHistory.columns">
                </Table>
                <div style="margin: 10px 0; overflow: hidden;">
                  <div style="float: right;">
                    <page
                      :total="examineHistory.count"
                      :current="examineHistory.page"
                      :page-size="examineHistory.size"
                      @on-change="getExamineHistory"></page>
                  </div>
                </div>
              </Row>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  </div>
</template>

<script>
import { detailConfigStrategy, getConfigExamineHistoryList, detailConfigExamineHistoryList,
  detailConfigVersionHistory } from '@/api/network'
import startExamine from '../components/start-examine'
import ConfigShow from '../config-show'
import PeriodicExamineModal from '../components/periodic-examine'

export default {
  name: 'detail',
  components: {
    startExamine,
    ConfigShow,
    PeriodicExamineModal
  },
  watch: {
    '$route' () {
      if (this.$route.params.id) {
        this.init()
      }
    }
  },
  data () {
    return {
      info: {},
      infoError: false,
      examineHistoryLoading: false,
      examineHistory: {
        data: [],
        columns: [
          {
            title: '开始时间',
            key: 'started_format',
            align: 'center',
            tooltip: true,
            minWidth: 150
          },
          {
            title: '结束时间',
            key: 'ended_format',
            align: 'center',
            tooltip: true,
            minWidth: 150
          },
          {
            title: '耗时(秒)',
            key: 'use_time',
            align: 'center',
            tooltip: true,
            minWidth: 100
          },
          {
            title: '执行用户',
            key: 'execute_user_full_name',
            align: 'center',
            tooltip: true,
            minWidth: 120
          },
          {
            title: '校验类型',
            key: 'style',
            align: 'center',
            tooltip: true,
            minWidth: 120,
            render: (h, params) => {
              let style = ''
              if (params.row.style === 'config') {
                style = '检测常规配置'
              } else if (params.row.style === 'order') {
                style = '检测命令输出'
              }
              return h('span', style)
            }
          },
          {
            title: '执行状态',
            key: 'status',
            minWidth: 100,
            fixed: 'right',
            align: 'center',
            render: (h, params) => {
              let iconType = 'md-clock'
              let style = {
                color: '#2d8cf0'
              }
              if (params.row.status === '完成') {
                iconType = 'md-checkmark'
                style.color = '#19be6b'
              } else if (params.row.status === '校验中') {
                iconType = 'ios-loading'
                style.color = '#ff9900'
                style.animation = 'ani-demo-spin 1s linear infinite'
              }
              return h('div', [
                h('Icon', {
                  props: {
                    type: iconType,
                    size: 20
                  },
                  style: style
                }),
                h('span', {
                  style: {
                    color: style.color
                  }
                }, ' ' + params.row.status)
              ])
            }
          },
          {
            title: '校验结果',
            align: 'center',
            fixed: 'right',
            minWidth: 150,
            render: (h, params) => {
              let result = []
              if (params.row.through) {
                if (params.row.through.pass) {
                  result.push(
                    h('span', {
                      style: {
                        color: '#19be6b'
                      }
                    }, '通过：' + params.row.through.pass + (params.row.through.fail ? '' : ' (ALL)'))
                  )
                }
                if (params.row.through.fail) {
                  result.push(
                    h('span', {
                      style: {
                        color: '#ed4014'
                      }
                    }, ' ' + ' 不通过：' + params.row.through.fail + (params.row.through.pass ? '' : ' (ALL)'))
                  )
                }
              }
              return h('div', result)
            }
          },
          {
            title: '操作',
            width: 70,
            fixed: 'right',
            align: 'center',
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  style: {
                    marginRight: '5px'
                  },
                  props: {
                    type: 'info',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      this.getExamineHistoryDetail(params.row.id)
                    }
                  }
                }, '详情')
              ])
            }
          }
        ],
        error: false,
        count: 0,
        page: 1,
        size: 5
      },
      examineHistoryDetail: {},
      examineHistoryDetailModal: false,
      typeList: [
        { label: '任意字符', value: 'str' },
        { label: '数字', value: 'int' },
        { label: '字符长度', value: 'length' },
        { label: '大写字母', value: 'higher' },
        { label: '小写字母', value: 'lower' },
        { label: '特殊符号', value: 'special' }
      ],
      styleList: [
        { label: '精确等于', value: 'exact', allowType: ['str', 'int', 'length'] },
        { label: '开头等于', value: 'startswith', allowType: ['str'] },
        { label: '结尾等于', value: 'endswith', allowType: ['str'] },
        { label: '包含关键字', value: 'contains', allowType: ['str'] },
        { label: '不包含关键字', value: 'excute', allowType: ['str'] },
        { label: '存在', value: 'exist', allowType: ['str', 'int', 'higher', 'lower', 'special'] },
        { label: '不存在', value: 'nexist', allowType: ['str', 'int', 'higher', 'lower', 'special'] },
        { label: '大于', value: 'gt', allowType: ['int', 'length'] },
        { label: '大于等于', value: 'gte', allowType: ['int', 'length'] },
        { label: '小于', value: 'lt', allowType: ['int', 'length'] },
        { label: '小于等于', value: 'lte', allowType: ['int', 'length'] }
      ],
      tab_value: '',
      no_global_valid_label: (h) => {
        return h('div', [
          h('span', '校验不通过 '),
          h('Badge', {
            props: {
              'show-zero': true,
              count: this.examineHistoryDetail.no_global_valid.length
            }
          })
        ])
      },
      global_valid_label: (h) => {
        return h('div', [
          h('span', '校验通过 '),
          h('Badge', {
            props: {
              type: 'success',
              'show-zero': true,
              count: this.examineHistoryDetail.global_valid.length
            }
          })
        ])
      },
      not_fount_label: (h) => {
        return h('div', [
          h('span', '未找到配置 '),
          h('Badge', {
            props: {
              type: 'warning',
              'show-zero': true,
              count: this.examineHistoryDetail.not_fount.length
            }
          })
        ])
      },
      not_backup_label: (h) => {
        return h('div', [
          h('span', '未找到备份 '),
          h('Badge', {
            props: {
              type: 'warning',
              'show-zero': true,
              count: this.examineHistoryDetail.not_backup.length
            }
          })
        ])
      },
      unreachable_label: (h) => {
        return h('div', [
          h('span', '连接不可达 '),
          h('Badge', {
            props: {
              type: 'warning',
              'show-zero': true,
              count: this.examineHistoryDetail.unreachable.length
            }
          })
        ])
      }
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    // 初始化
    init () {
      this.getData()
      this.listener()
      this.getExamineHistory()
    },
    // 获取策略数据
    getData () {
      this.infoError = false
      detailConfigStrategy(this.$route.params.id).then(res => {
        this.info = res.data
      }).catch(res => {
        this.infoError = true
        this.$Notice.error({ title: '获取策略数据失败' })
      })
    },
    // 跳转到编辑页
    edit () {
      this.$router.push({
        name: 'network_strategy_edit',
        params: { id: this.$route.params.id }
      })
    },
    // 打开开始校验Modal
    execModalOpen () {
      this.$refs.startExamine.openModal(this.info)
    },
    // 获取校验历史
    getExamineHistory (value = 1) {
      this.examineHistory.page = value
      let params = {
        size: this.examineHistory.size,
        page: this.examineHistory.page,
        strategy: this.$route.params.id
      }
      this.examineHistory.error = false
      this.examineHistoryLoading = true
      getConfigExamineHistoryList(params).then(res => {
        this.examineHistoryLoading = false
        this.examineHistory.data = res.data.results
        this.examineHistory.count = res.data.count
      }).catch(res => {
        this.examineHistoryLoading = false
        this.examineHistory.data = []
        this.examineHistory.count = 0
        this.examineHistory.error = true
        this.$Notice.error({ title: '获取校验历史数据失败' })
      })
    },
    // 获取校验历史详情
    getExamineHistoryDetail (id) {
      this.examineHistoryDetail = {}
      detailConfigExamineHistoryList(id).then(res => {
        this.examineHistoryDetail = res.data
        if (!this.tab_value) {
          if (this.examineHistoryDetail.no_global_valid.length) {
            this.tab_value = 'no_global_valid'
          } else if (this.examineHistoryDetail.global_valid.length) {
            this.tab_value = 'global_valid'
          } else if (this.examineHistoryDetail.not_fount.length) {
            this.tab_value = 'not_fount'
          } else if (this.examineHistoryDetail.not_backup.length) {
            this.tab_value = 'not_backup'
          } else if (this.examineHistoryDetail.unreachable.length) {
            this.tab_value = 'unreachable'
          } else {
            this.tab_value = 'no_global_valid'
          }
        }
        this.examineHistoryDetailModal = true
      }).catch(res => {
        this.$Notice.error({ title: '获取校验历史详情数据失败' })
      })
    },
    // 获取设备备份历史版本详情
    getConfigVersionHistoryDetail (id) {
      if (id) {
        detailConfigVersionHistory(id).then(res => {
          this.$refs.ConfigShow.openModal(res.data)
        }).catch(res => {
          this.$Notice.error({ title: '数据获取失败' })
        })
      }
    },
    // 拷贝到剪贴板
    dataCopy (data) {
      let that = this
      this.$copyText(data).then(function (e) {
        that.$Notice.success({ title: '拷贝成功！' })
      }, function (e) {
        that.$Notice.error({ title: '拷贝失败，请手动拷贝！' })
      })
    },
    // 监听WS消息
    listener () {
      this.$options.sockets.onmessage = (data) => {
        const fData = JSON.parse(data.data)
        if (fData.group === 'message' && fData.service === 'network' && fData.module === 'strategy_examine') {
          if (fData.data) {
            if (fData.data.strategy_id + '' === this.$route.params.id + '') {
              this.getExamineHistory(this.examineHistory.page)
            }
            if (fData.data.strategy_examine_log_id === this.examineHistoryDetail.id && this.examineHistoryDetailModal === true) {
              this.getExamineHistoryDetail(this.examineHistoryDetail.id)
            }
          }
        }
      }
    }
  }
}
</script>

<style lang="less">
  @import '../../base.less';
  @keyframes ani-demo-spin {
    from { transform: rotate(0deg);}
    50%  { transform: rotate(180deg);}
    to   { transform: rotate(360deg);}
  }
  .demo-spin-col{
    height: 100px;
    position: relative;
    border: 1px solid #eee;
  }
  li {
    list-style-type: none;
  }
  #detail-rule .ivu-input[disabled], #detail-rule .ivu-select-disabled .ivu-select-selection {
    color: #515a6e;
    background-color: #fff
  }
  .exec-logs-detail-c {
    font-size: 13px
  }
  .exec-logs-detail-c .exec-logs-detail-c-row {
    line-height: 25px;
    padding-left: 10px;
    display:block;
    width: 250px;
    float: left;
  }
  .detail-log-list {
    font-size: 13px;
  }
  .detail-log-list span {
    line-height: 25px;
  }
  .span-dt {
    font-weight: bold;
  }
  .detail-log-list .ivu-card-body {
    padding: 10px 5px 0 5px;
  }
  .detail-list-logs-scroll-bar {
    height: 500px;
    overflow-y: auto;
  }
  .detail-list-logs-scroll-bar::-webkit-scrollbar {
    width: 5px;
  }
  .detail-list-logs-scroll-bar::-webkit-scrollbar-track {
    border-radius: 5px;
    background-color: #eee;
  }
  .detail-list-logs-scroll-bar::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #dbdbdb;
  }
  @media screen and (max-width:640px){
    .content .main .info-property dl dt{
      width:105px;
    }
  }
</style>
